export enum CustomerAddressType {
    BillingAddress,
    ShipmentAddress,
    ContactAddress
}
